import {ModalBody, ModalHeader} from '_core/components/Modal'
import React from 'react'
import {Modal} from 'react-bootstrap'
import capitalize from 'lodash/capitalize'

interface Props {
  onClose: () => void
  orderStatusSummary: any
  title: string
}
export const StatusHistoryChangeDialog: React.FC<Props> = ({
  onClose,
  title,
  orderStatusSummary,
}) => {
  return (
    <Modal
      size='lg'
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='h-auto'
      show
      centered
    >
      <ModalHeader
        title={`${title}`}
        toolbar={{
          onClick: onClose,
        }}
      />
      <ModalBody>
        <div className='fw-bolder mt-1 mb-5'>Order Updates:</div>
        {orderStatusSummary.prevFinancialStatus &&
          orderStatusSummary.currentFinancialStatus &&
          orderStatusSummary.currentFinancialStatus !== orderStatusSummary.prevFinancialStatus && (
            <>
              <div className='fw-bolder my-3'>
                <ins>Payment Status</ins>
              </div>
              <StatusItem
                label='Previous Payment Status'
                value={orderStatusSummary.prevFinancialStatus}
              />
              <StatusItem
                label='Current Payment Status'
                value={orderStatusSummary.currentFinancialStatus}
              />
            </>
          )}

        {orderStatusSummary.prevFulfillmentStatus &&
          orderStatusSummary.currentFulfillmentStatus &&
          orderStatusSummary.currentFulfillmentStatus !==
            orderStatusSummary.prevFulfillmentStatus && (
            <>
              <div className='fw-bolder my-3'>
                <ins>Fulfillment Status</ins>
              </div>
              <StatusItem
                label='Previous Fulfillment Status'
                value={orderStatusSummary.prevFulfillmentStatus}
              />
              <StatusItem
                label='Current Fulfillment Status'
                value={orderStatusSummary.currentFulfillmentStatus}
              />
            </>
          )}

        {orderStatusSummary.note && (
          <div className='d-flex justify-content-between mb-3 fw-bold'>
            <div>Note : {orderStatusSummary.note}</div>
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

export default StatusHistoryChangeDialog

const StatusItem = ({label, value}: {label: string; value: any}) => {
  return (
    <div className='d-flex justify-content-between mb-3 fw-bold'>
      <div>{label}</div>
      <div>{capitalize(value)}</div>
    </div>
  )
}
